import React from 'react'
import Utils from 'utils/utils'
import { useStateValue } from 'context/store'
import { makeStyles, ListItem, ListItemText, Grid } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import NewIcon from 'components/commons/NewIcon'

const useStylesMenuListItemWithLink = makeStyles(() => ({
   subItemText: {
      font: 'normal normal normal 14px/19px Roboto',
      // letterSpacing: '0px',
      paddingLeft: '4px',
      flex: '0 !important'
   },
   selectedSecondaryItem: {
      backgroundColor: '#3264DC08'
   },
   selectedSecondaryItemText: {
      color: '#3264DC',
      display: 'flex',
      margin: '0.5rem 0',
      'MuiListItemText-root': {
         flex: 'none !important'
      }
   }
}))

const SecondaryMenuItem = ({
   submenu,
   setOpen,
   open,
   buildCollapsableMenu
}) => {
   const classes = useStylesMenuListItemWithLink()
   const itemTitle = Utils.getNoSpaceTitle(submenu.title)
   const [{ secondaryMenuItemSelection }, dispatch] = useStateValue()

   const handleClick = submenu => {
      if (secondaryMenuItemSelection.initialState.hasOwnProperty(itemTitle)) {
         dispatch({ type: 'SECONDARY_MENU_ITEM_SELECTED', itemTitle })
      }
      setOpen(prev => ({
         ...prev,
         [submenu.id]: !prev[submenu.id]
      }))
   }

   return (
      <Grid
         key={submenu.id}
         className={
            secondaryMenuItemSelection.currentState[itemTitle]
               ? classes.selectedSecondaryItem
               : ''
         }
      >
         {submenu.isVisible ? (
            <ListItem
               className={
                  secondaryMenuItemSelection.currentState[itemTitle]
                     ? classes.selectedSecondaryItemText
                     : ''
               }
               onClick={() => handleClick(submenu)}
               button
            >
               <ListItemText
                  classes={{ primary: classes.subItemText }}
                  primary={submenu.title}
               />
               {submenu?.newOption ? <NewIcon /> : null}
               {open[submenu.id] ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
         ) : null}

         {submenu?.menus?.length ? buildCollapsableMenu(submenu) : ''}
      </Grid>
   )
}

export default SecondaryMenuItem
